import request from 'src/utils/http-smartoffice';
import constants from '../../../constants';

export class WorkspaceAppApi {
  getAll(): Promise<any[]> {
    return request
      .get(constants.SSO_URL_WORKSPACE_APPS)
      .then(response => response.data as any[]);
  }
}

export const workspaceAppApi = new WorkspaceAppApi();
